export var HeatmapScaleTypes;
(function (HeatmapScaleTypes) {
    HeatmapScaleTypes["LINEAR"] = "linear";
    HeatmapScaleTypes["LOGARITHMIC"] = "logarithmic";
})(HeatmapScaleTypes || (HeatmapScaleTypes = {}));
export const HEATMAP_SCALE_LABELS = {
    [HeatmapScaleTypes.LINEAR]: 'Actual value',
    [HeatmapScaleTypes.LOGARITHMIC]: 'Logarithmic'
};
